import { LOGIN_VIEWS } from './loginViews';
import { STEPS } from '../mfa/TotpEnrollment';

export const STAGES = { CONFIGURE: 0, VERIFY: 1, FINISH: 2 };

const TOTP_STEP_TO_STAGE = {
  [STEPS.QR]: STAGES.CONFIGURE,
  [STEPS.CONFIRM]: STAGES.VERIFY,
  [STEPS.SUCCESS]: STAGES.FINISH,
};

export function stageFor(view, enrollStep, isLogin) {
  if (view === LOGIN_VIEWS.MFA_ENROLLMENT_CHOOSER) return STAGES.CONFIGURE;
  if (view === LOGIN_VIEWS.TOTP_ENROLLMENT) {
    return TOTP_STEP_TO_STAGE[enrollStep] ?? STAGES.CONFIGURE;
  }
  if (view === LOGIN_VIEWS.PHONE_ENROLLMENT) return STAGES.CONFIGURE;
  if (view === LOGIN_VIEWS.SMS_CODE && !isLogin) return STAGES.VERIFY;
  if (view === LOGIN_VIEWS.SMS_SUCCESS) return STAGES.FINISH;
  return null;
}
